import React from "react";
import "./modal-client.scss";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "../../../components/modal-components/dialog-title";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadingUnpaid } from "../../../store/actions/auth";

const UnpaidInvoice = (props) => {
  const dispatch = useDispatch();
  const { open, id } = props;
  return (
    <Dialog open={open} aria-labelledby="form-dialog" fullWidth maxWidth={"sm"}>
      <DialogTitle id="form-dialog-paid">
        У вас есть неоплаченные занятия
      </DialogTitle>
      <DialogContent id="paidInvoiceClient">
        <p>
          Перейдите в раздел абонементы и оплатите занятия, чтобы продолжить
          посещения.
        </p>
      </DialogContent>
      <DialogActions id="paidInvoiceClientBtn">
        <Button
          variant="contained"
          color="primary"
          onClick={() => dispatch(loadingUnpaid(false))}
        >
          Закрыть
        </Button>

        <Button
          id="bntCheckUnpaid"
          variant="contained"
          color="primary"
          onClick={() => dispatch(loadingUnpaid(false))}
        >
          <Link to={`/client/invoice/${id}`}>К оплате</Link>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnpaidInvoice;
